"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStateType = void 0;
exports.SessionStateType = { Authenticated: 'Authenticated', NotAuthenticated: 'NotAuthenticated', Expired: 'Expired' };
